module.exports = __webpack_public_path__ + "static/media/our-partners-img1.06b747e4.svg";